<h2 mat-dialog-title class="dialog-user-profile__title">{{ data.title }}</h2>

<mat-dialog-content class="dialog-user-profile__content">
  @if (data.message) {
    <p class="dialog-user-profile__message">{{ data.message }}</p>
  }

  <form
    id="userProfileForm"
    class="dialog-user-profile__form"
    [formGroup]="profileForm"
    (ngSubmit)="onSubmit()"
  >
    <!-- Personal Information Section -->
    <div class="dialog-user-profile__section">
      <h3 class="dialog-user-profile__section-title">
        {{ 'userProfile.sections.personalInformation' | translate }}
      </h3>

      <div class="dialog-user-profile__field">
        <ui-molecule-input
          textId="firstName"
          formControlName="firstName"
          label="{{ 'userProfile.fields.firstName' | translate }}"
          placeholder="{{ 'userProfile.placeholders.firstName' | translate }}"
        />
      </div>

      <div class="dialog-user-profile__field">
        <ui-molecule-input
          textId="lastName"
          formControlName="lastName"
          label="{{ 'userProfile.fields.lastName' | translate }}"
          placeholder="{{ 'userProfile.placeholders.lastName' | translate }}"
        />
      </div>

      <div class="dialog-user-profile__field">
        <ui-molecule-input
          textId="email"
          formControlName="email"
          label="{{ 'userProfile.fields.email' | translate }}"
          placeholder="{{ 'userProfile.placeholders.email' | translate }}"
        />
      </div>
    </div>

    <!-- Change Password Section -->
    <div class="dialog-user-profile__section">
      <h3 class="dialog-user-profile__section-title">
        {{ 'userProfile.sections.changePassword' | translate }}
      </h3>

      <div class="dialog-user-profile__field">
        <ui-molecule-input
          textId="currentPassword"
          formControlName="currentPassword"
          label="{{ 'userProfile.fields.currentPassword' | translate }}"
          placeholder="{{ 'userProfile.placeholders.currentPassword' | translate }}"
          [type]="hideCurrentPassword ? 'password' : 'text'"
        />
      </div>

      <div class="dialog-user-profile__field">
        <ui-molecule-input
          textId="newPassword"
          formControlName="newPassword"
          label="{{ 'userProfile.fields.newPassword' | translate }}"
          placeholder="{{ 'userProfile.placeholders.newPassword' | translate }}"
          [type]="hideNewPassword ? 'password' : 'text'"
        />
      </div>

      <div class="dialog-user-profile__field">
        <ui-molecule-input
          textId="confirmPassword"
          formControlName="confirmPassword"
          label="{{ 'userProfile.fields.confirmPassword' | translate }}"
          placeholder="{{ 'userProfile.placeholders.confirmPassword' | translate }}"
          [type]="hideConfirmPassword ? 'password' : 'text'"
        />
      </div>

      <!-- Password validation errors -->
      <div
        class="dialog-user-profile__errors"
        *ngIf="newPasswordControl?.invalid && newPasswordControl?.touched"
      >
        <div class="dialog-user-profile__error" *ngIf="newPasswordControl?.hasError('minlength')">
          {{ 'userProfile.errors.passwordMinLength' | translate }}
        </div>
        <div class="dialog-user-profile__error" *ngIf="newPasswordControl?.hasError('maxlength')">
          {{ 'userProfile.errors.passwordMaxLength' | translate }}
        </div>
      </div>

      <div class="dialog-user-profile__errors" *ngIf="passwordMismatchError">
        <div class="dialog-user-profile__error">
          {{ 'userProfile.errors.passwordMismatch' | translate }}
        </div>
      </div>
    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end" class="dialog-user-profile__actions">
  <ui-atom-button
    type="button"
    rules="main"
    styling="outlined"
    [withShadow]="false"
    [text]="'userProfile.buttons.cancel' | translate"
    (buttonClick)="onCancel()"
  >
  </ui-atom-button>

  <ui-atom-button
    type="button"
    rules="main"
    styling="filled"
    [withShadow]="true"
    [text]="'userProfile.buttons.save' | translate"
    [disabled]="profileForm.invalid || isLoading"
    (buttonClick)="onSubmit()"
  >
  </ui-atom-button>
</mat-dialog-actions>
